import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["departmentSelect", "rolesSection"]
  static values = { departmentsUrl: String }

  schoolChanged(event) {
    const schoolId = event.target.value
    if (!schoolId) {
      this.departmentSelectTarget.innerHTML = '<option value="">-- Select --</option>'
      return
    }

    const url = `${this.departmentsUrlValue}?school_id=${schoolId}`
    fetch(url, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => this.replaceDepartments(html))
  }

  // La liste est habillée par SlimSelect, qui garde ses propres options : lui
  // donner les nouvelles, sinon il remet les anciennes à la place.
  replaceDepartments(html) {
    const select = this.departmentSelectTarget
    if (!select.slim) {
      select.innerHTML = html
      return
    }

    const holder = document.createElement("select")
    holder.innerHTML = html
    select.slim.setData(
      [...holder.options].map((option) => ({
        text: option.text,
        value: option.value,
        placeholder: option.value === "",
      }))
    )
  }

  toggleAccess(event) {
    if (event.target.checked) {
      this.rolesSectionTarget.classList.remove("hidden")
    } else {
      this.rolesSectionTarget.classList.add("hidden")
    }
  }
}
